export const initialLaboratoriesState = {
    laboratory: {
        address: null,
        name: null,
        npt_device_id: null,
        id: null,
        pharmacy_site_id: null,
        dms_id: null,
        is_registered: false,
        created_at: null,
        updated_at: null,
        post_code: null,
        phone: null,
        fax: null,
        email: null,
        prn: null,
    },
    collection_centre: {
        address: null,
        contacts_information: null,
        courier_details: null,
        courier_phone: null,
        id: null,
        name: null,
        pharmacy_site_id: null,
        dms_id: null,
        created_at: null,
        updated_at: null,
        post_code: null,
        phone: null,
        fax: null,
        email: null,
        type: null,
        is_registered: false,
        prn: null,
    },
};
const NotificationLaboratory = {
    namespaced: true,
    state: {
        currentForm: 0,
        laboratory: initialLaboratoriesState.laboratory,
        collection_centre: initialLaboratoriesState.collection_centre,
        laboratorySnapShot: initialLaboratoriesState.laboratory,
        collection_centreSnapShot: initialLaboratoriesState.collection_centre,
        errorMessages: {
            laboratory: {
                address: [],
                npt_device_id: [],
                id: [],
                name: [],
                pharmacy_site_id: [],
                dms_id: [],
                is_registered: [],
                created_at: [],
                updated_at: [],
                post_code: [],
                phone: [],
                fax: [],
                email: [],
                prn: [],
            },
            collection_centre: {
                address: [],
                contacts_information: [],
                courier_details: [],
                courier_phone: [],
                id: [],
                name: [],
                pharmacy_site_id: [],
                dms_id: [],
                created_at: [],
                updated_at: [],
                post_code: [],
                phone: [],
                fax: [],
                email: [],
                type: [],
                is_registered: [],
                prn: [],
            },
        },
        nptDevicesOptions: [],
        astmDevicesOptions: [],
        updatedProps: [],
    },
    mutations: {
        SET_FORM_PROPERTY(state, data) {
            _.set(state, data.property, data.value);
        },
        SET_CURRENT_FORM(state, data) {
            state.currentForm = data;
        },
        SET_NPT_DEVICES_OPTIONS(state, data) {
            state.nptDevicesOptions = data;
        },
        SET_ASTM_DEVICES_OPTIONS(state, data) {
            state.astmDevicesOptions = data;
        },
        SET_LABORATORY_SNAP_SHOT(state, data) {
            state.laboratorySnapShot = data;
        },
        SET_COLLECTION_CENTRE_SNAP_SHOT(state, data) {
            state.collection_centreSnapShot = data;
        },
        SET_DATA_FOR_FORM(state, data) {
            state[data.formToSet] = data.data;
        },
        SET_ERROR_MESSAGE(state, data) {
            _.set(state.errorMessages, data.property, data.value);
            // state.errorMessages[data.property] = data.value;
            // _.set(state, data.property, data.value);
        },
        RESET_CURRENT_FORM(state) {
            state.currentForm = 0;
        },
        REMAP_SELECTED_DEVICES(state) {
            let selectedDevices = [];
            state.nptDevicesOptions.map((device) => {
                if (device.laboratory_id && device.laboratory_id === state.laboratory.id) {
                    selectedDevices.push(device.id);
                }
            });
        },
        SET_UPDATED_PROPS(state, props) {
            state.updatedProps = props;
        },
    },
    actions: {
        changeForm({ commit }, data) {
            commit('SET_CURRENT_FORM', data);
        },
        updateProperty({ commit }, data) {
            commit('SET_FORM_PROPERTY', data);
        },
        loadDataForForm({ commit }, data) {
            commit('SET_DATA_FOR_FORM', data);
            commit('REMAP_SELECTED_DEVICES');
        },
        loadLaboratorySnapShot({ commit }, data) {
            commit('SET_LABORATORY_SNAP_SHOT', data);
        },
        loadCollectionCentreSnapShot({ commit }, data) {
            commit('SET_COLLECTION_CENTRE_SNAP_SHOT', data);
        },
        resetForm({ commit }) {
            commit('RESET_CURRENT_FORM');
        },
        resetErrorMessages({ commit, state }) {
            _.each(state.errorMessages, function (messages, field) {
                const vueObjectToPlain = JSON.parse(JSON.stringify(state.errorMessages[field]));
                if (_.isPlainObject(vueObjectToPlain)) {
                    _.each(state.errorMessages[field], function (messages, plainObjectField) {
                        commit('SET_ERROR_MESSAGE', { value: [], property: `${field}.${plainObjectField}` });
                    });
                } else {
                    commit('SET_ERROR_MESSAGE', { value: [], property: field });
                }
            });
        },
        loadNPTDevicesOptions({ commit }, data) {
            axios
                .get(
                    route('api.v1.npt-devices.options', {
                        sort: 'name',
                        is_registered: 1,
                        not_assigned: data.id ? data.id : 1,
                    })
                )
                .then((response) => {
                    const data = response.data.data;
                    commit('SET_NPT_DEVICES_OPTIONS', data);
                    commit('REMAP_SELECTED_DEVICES');
                });
        },
        loadASTMDevicesOptions({ commit }) {
            axios
                .get(
                    route('api.v1.astm-devices.options', {
                        sort: 'name',
                        active: 1,
                    })
                )
                .then((response) => {
                    const data = response.data.data;
                    commit('SET_ASTM_DEVICES_OPTIONS', data);
                });
        },
        setUpdatedProps({ commit }, props) {
            commit('SET_UPDATED_PROPS', props);
        },
        setErrorMessages({ commit, state }, errors) {
            const propertyToAdd = state.currentForm === 'laboratories' ? 'laboratory.' : 'collection_centre.';

            _.each(errors, function (fieldErrors) {
                const errorMessageField = _.get(state.errorMessages, propertyToAdd + fieldErrors.field);

                if (fieldErrors.field && errorMessageField !== undefined) {
                    if (fieldErrors.field == 'diagnosis') {
                        fieldErrors.field = 'diagnosis.diagnosis';
                    }

                    commit('SET_ERROR_MESSAGE', {
                        value: fieldErrors.errors,
                        property: propertyToAdd + fieldErrors.field,
                    });
                }
            });
        },
    },
};

export default NotificationLaboratory;
